module.exports = __webpack_public_path__ + "img/微信图片_20251028123244_209_595.2278116e.jpg";